import Vue from 'vue';
import SmartFilter from '@/components/SmartFilter/SmartFilter.vue';
import { SmartFilterProps } from '@/components/SmartFilter/types';
import { JSONParser } from '@/utils/JSONParser';
import { SelectOptions } from '@/components/Controls/Select/types';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';

export function createSmartFilterWidget(el: Element) {
    const parser = new JSONParser('createSmartFilterWidget');
    const rootAttrs = new RootElementAttrsHolder(el);

    const action = el.getAttribute('action');
    const method = el.getAttribute('method');
    const url = el.getAttribute('data-smart-filter-form-content-url');
    const doNotShowSmartFilter = el.getAttribute('data-do-not-show-smart-filter-form');
    const housingOptions = el.getAttribute('data-housing-options');
    const housingPlaceholder = el.getAttribute('data-housing-placeholder');
    const housing = el.getAttribute('data-housing');
    const metrix = el.getAttribute('data-metrix');

    const props: SmartFilterProps = {
        action,
        method,
        url,
        doNotShowSmartFilter: parser.parse<boolean>(doNotShowSmartFilter),
        housingOptions: parser.parse<SelectOptions>(housingOptions),
        housingPlaceholder,
        housing,
        metrix: parser.parse<object>(metrix),
    };

    return new Vue({
        el,
        name: 'SmartFilterWidget',
        rootAttrs,
        render: (h) => h(SmartFilter, { props }),
    });
}
